import { Auth, Hub } from 'aws-amplify';

import useChatbotStore from '@/components/Chatbot/store/useChatbotStore';

type RememberLastUserPath = () => void;
type SignOut = typeof Auth.signOut;

export const resetChatbotState = (): void => {
  useChatbotStore.getState().reset();
};

export const rememberPathAndSignOut = (
  rememberLastUserPath: RememberLastUserPath,
  signOut: SignOut = Auth.signOut.bind(Auth),
): ReturnType<SignOut> => {
  rememberLastUserPath();
  resetChatbotState();

  return signOut();
};

export const registerAuthHubListener = (rememberLastUserPath: RememberLastUserPath): VoidFunction =>
  Hub.listen('auth', ({ payload: { event, data } }) => {
    switch (event) {
      case 'tokenRefresh_failure': {
        void rememberPathAndSignOut(rememberLastUserPath);
        break;
      }
      case 'signIn_failure':
        localStorage.setItem('cognito-error', decodeURIComponent(data)?.replaceAll('+', ' ') ?? 'Error occurred');
        break;
      default:
        break;
    }
  });
